import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CampaignCreationResult } from "@/components/campaign-creation/CampaignCreationResult";
import { requireModule } from "@/lib/module-access";

export const Route = createFileRoute("/_authed/campaigns/new_/$requestId")({
  beforeLoad: () => {
    requireModule("campaigns");
  },
  params: {
    parse: (params) => z.object({ requestId: z.string().uuid() }).parse(params),
  },
  component: CampaignCreationResultRoute,
});

function CampaignCreationResultRoute() {
  const { requestId } = Route.useParams();
  return <CampaignCreationResult requestId={requestId} />;
}
